let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aJNOs")).then(() => parcelRequire('Zqh0A'));